"use client"
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/searchParam.ts
function hasStringtaleParam() {
  if (typeof window === "undefined") return false;
  const urlParams = new URLSearchParams(window.location.search);
  const hasParam = !!urlParams.has("stringtale");
  return hasParam;
}
function removeStringtaleParam() {
  let params = new URLSearchParams(window.location.search);
  params.delete("stringtale");
  window.location.search = params.toString();
}
var init_searchParam = __esm({
  "src/utils/searchParam.ts"() {
    "use strict";
  }
});

// src/utils/useSessionStorageState.ts
function useSessionStorageState(key, options) {
  const [defaultValue] = (0, import_react.useState)(options == null ? void 0 : options.defaultValue);
  if (typeof window === "undefined") {
    return [
      defaultValue,
      () => {
      },
      {
        isPersistent: true,
        removeItem: () => {
        }
      }
    ];
  }
  const serializer = options == null ? void 0 : options.serializer;
  return useBrowserSessionStorageState(
    key,
    defaultValue,
    options == null ? void 0 : options.storageSync,
    serializer == null ? void 0 : serializer.parse,
    serializer == null ? void 0 : serializer.stringify
  );
}
function useBrowserSessionStorageState(key, defaultValue, storageSync = true, parse = parseJSON, stringify = JSON.stringify) {
  if (!inMemoryData.has(key) && defaultValue !== void 0 && goodTry(() => sessionStorage.getItem(key)) === null) {
    goodTry(() => sessionStorage.setItem(key, stringify(defaultValue)));
  }
  const storageValue = (0, import_react.useRef)({
    item: null,
    parsed: defaultValue
  });
  const value = (0, import_react.useSyncExternalStore)(
    (0, import_react.useCallback)(
      (onStoreChange) => {
        const onChange = (localKey) => {
          if (key === localKey) {
            onStoreChange();
          }
        };
        callbacks.add(onChange);
        return () => {
          callbacks.delete(onChange);
        };
      },
      [key]
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    () => {
      var _a;
      const item = (_a = goodTry(() => sessionStorage.getItem(key))) != null ? _a : null;
      if (inMemoryData.has(key)) {
        storageValue.current = {
          item,
          parsed: inMemoryData.get(key)
        };
      } else if (item !== storageValue.current.item) {
        let parsed;
        try {
          parsed = item === null ? defaultValue : parse(item);
        } catch (e) {
          parsed = defaultValue;
        }
        storageValue.current = {
          item,
          parsed
        };
      }
      return storageValue.current.parsed;
    },
    // istanbul ignore next
    () => defaultValue
  );
  const setState = (0, import_react.useCallback)(
    (newValue) => {
      const value2 = newValue instanceof Function ? newValue(storageValue.current.parsed) : newValue;
      try {
        sessionStorage.setItem(key, stringify(value2));
        inMemoryData.delete(key);
      } catch (e) {
        inMemoryData.set(key, value2);
      }
      triggerCallbacks(key);
    },
    [key, stringify]
  );
  (0, import_react.useEffect)(() => {
    if (!storageSync) {
      return void 0;
    }
    const onStorage = (e) => {
      if (e.storageArea === goodTry(() => sessionStorage) && e.key === key) {
        triggerCallbacks(key);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [key, storageSync]);
  return (0, import_react.useMemo)(
    () => [
      value,
      setState,
      {
        isPersistent: value === defaultValue || !inMemoryData.has(key),
        removeItem() {
          goodTry(() => sessionStorage.removeItem(key));
          inMemoryData.delete(key);
          triggerCallbacks(key);
        }
      }
    ],
    [key, setState, value, defaultValue]
  );
}
function triggerCallbacks(key) {
  for (const callback of [...callbacks]) {
    callback(key);
  }
}
function parseJSON(value) {
  return value === "undefined" ? void 0 : JSON.parse(value);
}
function goodTry(tryFn) {
  try {
    return tryFn();
  } catch (e) {
    return void 0;
  }
}
var import_react, inMemoryData, callbacks;
var init_useSessionStorageState = __esm({
  "src/utils/useSessionStorageState.ts"() {
    "use strict";
    import_react = require("react");
    inMemoryData = /* @__PURE__ */ new Map();
    callbacks = /* @__PURE__ */ new Set();
  }
});

// src/utils/useStateWithUpdateControl.ts
function useStateWithUpdateControl(initialState) {
  const stateRef = (0, import_react2.useRef)(initialState);
  const [state, setInternalState] = (0, import_react2.useState)(initialState);
  const cachedFuncs = (0, import_react2.useRef)(/* @__PURE__ */ new WeakMap());
  const [updateCount, setUpdateCount] = (0, import_react2.useState)(0);
  let funcs = [];
  const useSelector = (fnc) => {
    funcs.push(fnc);
    return fnc(stateRef.current);
  };
  const flush = (0, import_react2.useCallback)(() => {
    setInternalState(stateRef.current);
  }, []);
  const setState = (0, import_react2.useCallback)((valueOrFunc, doFlush) => {
    const value = valueOrFunc instanceof Function ? valueOrFunc(stateRef.current) : valueOrFunc;
    if (stateRef.current !== value) {
      stateRef.current = value;
      let isChanged = false;
      for (const fnc of funcs) {
        const newValue = fnc(value);
        const oldValue = cachedFuncs.current.get(fnc);
        if (!cachedFuncs.current.has(fnc) || newValue !== oldValue) {
          isChanged = true;
          cachedFuncs.current.set(fnc, newValue);
        }
      }
      if (isChanged) {
        setUpdateCount((c) => c + 1);
      }
    }
    if (doFlush) {
      flush();
    }
  }, [updateCount]);
  return { stateRef, state, useSelector, setState, flush };
}
var import_react2;
var init_useStateWithUpdateControl = __esm({
  "src/utils/useStateWithUpdateControl.ts"() {
    "use strict";
    import_react2 = require("react");
  }
});

// src/utils/updateData.ts
function updateData(data, state) {
  const keys = Object.keys(state);
  const newData = (data || []).map((item) => {
    if (keys.includes(item.key)) {
      keys.splice(keys.indexOf(item.key), 1);
      let hasSelector = false;
      const newValues = item.values.map((value) => {
        if (value.selector === "") {
          hasSelector = true;
          return __spreadProps(__spreadValues({}, value), {
            value: state[item.key].value
          });
        }
        return value;
      });
      if (hasSelector) {
        return __spreadProps(__spreadValues({}, item), {
          values: newValues,
          version: (state[item.key].version || 0) + 1
        });
      }
      return __spreadProps(__spreadValues({}, item), {
        values: [
          ...item.values,
          {
            value: state[item.key].value,
            selector: ""
          }
        ],
        version: (state[item.key].version || 0) + 1
      });
    }
    return item;
  });
  if (keys.length > 0) {
    for (const key of keys) {
      newData.push({
        key,
        values: [
          {
            value: state[key].value,
            selector: ""
          }
        ],
        version: (state[key].version || 0) + 1
      });
    }
  }
  return newData;
}
var init_updateData = __esm({
  "src/utils/updateData.ts"() {
    "use strict";
  }
});

// ../../packages/ui/Logo.tsx
function Logo({
  width,
  height,
  fill = "#fff",
  className
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "svg",
    {
      width: width || "142",
      height: height || "30",
      viewBox: "0 0 142 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M27.5715 8.31438L14.9739 0.70001C12.6815 -0.685567 9.69995 0.049536 8.31438 2.34191L0.70001 14.9395C-0.685567 17.2319 0.049536 20.2135 2.34191 21.599L14.9395 29.2134C17.2319 30.599 20.2135 29.8639 21.599 27.5715L29.2134 14.9739C30.599 12.6815 29.8639 9.69995 27.5715 8.31438Z",
            fill: "#ACA1E3"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M25.0256 6.69892L27.2556 8.02892C27.6356 8.25892 27.9756 8.52892 28.2656 8.83892C27.1156 8.60892 25.7456 8.53892 24.3656 8.83892C22.8656 9.15892 20.6256 10.1189 18.3056 11.6389C18.7956 13.0189 19.0356 14.5389 18.9256 15.9289C18.6956 18.8589 17.6556 21.1189 16.0056 22.2889C15.2356 22.8389 14.3456 23.1189 13.4356 23.1189C13.0456 23.1189 12.6556 23.0689 12.2656 22.9689C11.0756 22.6589 10.2156 21.7889 9.9156 20.5889C9.3656 18.3889 10.7056 15.4589 13.4156 12.9389C14.1956 12.2189 14.9956 11.5589 15.8056 10.9489C15.5756 10.5589 15.3256 10.2189 15.0456 9.92892C14.7056 9.57892 14.1856 9.17892 13.6056 9.20892C12.6656 9.25892 11.9556 10.0889 11.1256 11.0589C10.2556 12.0789 9.2656 13.2289 7.7856 13.5489C6.4756 13.8289 5.3056 13.5389 4.4556 12.7289C3.0256 11.3589 2.6556 8.70892 3.3356 4.83892C3.4256 4.28892 3.9456 3.92892 4.4856 4.01892C5.0256 4.10892 5.3956 4.62892 5.2956 5.17892C4.5456 9.50892 5.4056 10.8789 5.8156 11.2689C5.9456 11.3989 6.3556 11.7889 7.3356 11.5689C8.1656 11.3889 8.8556 10.5889 9.5856 9.72892C10.5756 8.57892 11.6856 7.26892 13.4856 7.17892C14.5456 7.12892 15.5656 7.58892 16.4656 8.50892C16.8156 8.86892 17.1456 9.29892 17.4356 9.77892C19.8856 8.20892 22.2556 7.20892 23.9356 6.84892C24.2956 6.76892 24.6556 6.70892 25.0256 6.66892V6.69892ZM16.5856 12.8389C15.9656 13.3189 15.3556 13.8289 14.7556 14.3789C12.3156 16.6489 11.5256 18.8789 11.8256 20.0789C11.9456 20.5789 12.2456 20.8789 12.7456 21.0089C13.4956 21.2089 14.1956 21.0789 14.8256 20.6389C15.9656 19.8289 16.7256 18.0489 16.9056 15.7589C16.9756 14.8289 16.8556 13.7989 16.5756 12.8389H16.5856Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M26.0056 24.6079L26.7249 20.4829C28.3032 20.8683 29.7257 21.0558 30.9872 21.0558C32.2487 21.0558 33.2687 21.0037 34.0417 20.9047V19.6547L31.7227 19.4568C29.6291 19.2745 28.1904 18.785 27.4067 17.9933C26.6229 17.2016 26.2364 16.0298 26.2364 14.4829C26.2364 12.3527 26.7142 10.8839 27.6697 10.0818C28.6252 9.27975 30.2411 8.88392 32.5225 8.88392C34.804 8.88392 36.8707 9.09225 38.7066 9.50892L38.0624 13.5089C36.4627 13.2589 35.1851 13.1339 34.2242 13.1339C33.2633 13.1339 32.4474 13.1756 31.7763 13.2589V14.4829L33.6337 14.66C35.883 14.8787 37.4397 15.3995 38.2986 16.2225C39.1575 17.0454 39.587 18.1912 39.587 19.66C39.587 20.712 39.442 21.5975 39.1468 22.3214C38.8569 23.0454 38.508 23.5975 38.1054 23.9725C37.7028 24.3475 37.1284 24.6339 36.3929 24.837C35.6521 25.035 35.008 25.16 34.4497 25.2016C33.8914 25.2433 33.1506 25.2641 32.2219 25.2641C29.9888 25.2641 27.9167 25.0454 26.011 24.6131L26.0056 24.6079Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M40.7465 15.6079V12.3839H42.0348V10.3839L47.1883 9.13392V12.3839H48.9651V15.6079H47.1883V21.3058C47.6338 21.3891 48.1438 21.4464 48.7074 21.4829L48.4766 25.16C46.1254 25.16 44.5954 25.035 43.8922 24.785C43.0172 24.4829 42.4643 24.087 42.2442 23.587C42.1046 23.285 42.0402 22.936 42.0402 22.535V15.6079H40.7465Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M50.8976 12.3839H53.4743L54.8915 13.785C55.9061 12.8839 57.1783 12.2954 58.7029 12.0089L59.0143 16.7329C58.6009 16.7485 58.0641 16.8475 57.4038 17.035C56.7435 17.2172 56.2926 17.4516 56.051 17.7329V24.8839H50.8976V12.3839Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M60.8555 11.5818C60.469 11.3006 60.2758 10.7797 60.2758 10.0297C60.2758 9.27975 60.469 8.75371 60.8555 8.45683C61.242 8.15475 62.0043 8.00892 63.1477 8.00892C64.2911 8.00892 65.0534 8.15996 65.4399 8.45683C65.8264 8.75892 66.0197 9.27975 66.0197 10.0297C66.0197 10.7797 65.8264 11.2954 65.4399 11.5818C65.0534 11.8631 64.2911 12.0089 63.1477 12.0089C62.0043 12.0089 61.242 11.8683 60.8555 11.5818ZM60.5603 24.8839V13.0089L65.7137 12.3839V24.8839H60.5603Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M70.8671 12.3839L72.1554 13.6339C73.7551 12.5506 75.473 12.0089 77.3089 12.0089C78.5113 12.0089 79.4561 12.2641 80.1432 12.7693C80.8304 13.2797 81.1739 13.9829 81.1739 14.8839V24.8839H76.0205V16.1339H75.2207C74.6355 16.1339 74.1953 16.1964 73.8947 16.3214C73.5941 16.4464 73.4438 16.7016 73.4438 17.0818V24.8839H68.2904V12.3839H70.8671Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M82.9239 28.2589L83.5949 24.535C85.0551 25.0193 86.7621 25.2589 88.7215 25.2589C89.3066 25.2589 89.72 25.2433 89.9562 25.2068V24.3318C88.4263 24.3318 87.4278 24.2693 86.9554 24.1443C86.483 24.0193 86.1716 23.8943 86.0267 23.7693C85.8818 23.6443 85.7959 23.5402 85.769 23.4568C85.7422 23.3735 85.7315 23.2589 85.7315 23.1079L86.5045 20.9568C85.2698 20.7381 84.325 20.2902 83.6808 19.6079C83.0367 18.9256 82.7146 17.8527 82.7146 16.3943C82.7146 14.936 83.2192 13.8422 84.2337 13.1079C85.2483 12.3735 86.8963 12.0089 89.1832 12.0089C90.0099 12.0089 90.7399 12.061 91.3734 12.16L93.6172 10.4829L96.3228 13.0089L94.8519 14.686C95.0774 15.2693 95.1847 16.0193 95.1847 16.936C95.1847 18.2537 94.8465 19.2329 94.1648 19.8735C93.4884 20.5141 92.2806 20.9047 90.5467 21.035L90.4447 21.6339C92.3021 21.7329 93.6119 22.0037 94.3742 22.4464C95.1364 22.8891 95.5229 23.7016 95.5229 24.8839C95.5229 26.8995 94.5191 28.1495 92.506 28.6339C91.5076 28.8839 90.1655 29.0089 88.4746 29.0089C86.7836 29.0089 84.9316 28.7589 82.9239 28.2589ZM87.562 16.3839V18.0089H88.3618C88.9792 18.0089 89.4301 17.9464 89.7146 17.8214C89.9991 17.6964 90.1387 17.41 90.1387 16.9568V15.3318H89.3388C88.7215 15.3318 88.2706 15.3943 87.9861 15.5193C87.7016 15.6443 87.562 15.9308 87.562 16.3839Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M96.6556 15.6079V12.3839H97.944V10.3839L103.097 9.13392V12.3839H104.874V15.6079H103.097V21.3058C103.543 21.3891 104.053 21.4464 104.617 21.4829L104.386 25.16C102.034 25.16 100.505 25.035 99.8013 24.785C98.9263 24.4829 98.3734 24.087 98.1533 23.587C98.0137 23.285 97.9493 22.936 97.9493 22.535V15.6079H96.6556Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M112.916 12.0089C117.038 12.0089 119.1 13.3839 119.1 16.1339V24.8839H116.523L115.052 23.4568C114.553 24.0245 113.877 24.4673 113.018 24.7798C112.159 25.0923 111.348 25.2537 110.581 25.2537C109.813 25.2537 109.201 25.1964 108.739 25.0766C108.278 24.9568 107.821 24.7589 107.376 24.4777C106.399 23.8787 105.905 22.7589 105.905 21.1287C105.905 18.1287 108.24 16.6287 112.916 16.6287H113.946V15.7277C113.399 15.6964 112.943 15.6756 112.583 15.6756C110.64 15.6756 108.975 15.8995 107.585 16.3527L106.968 12.7797C108.686 12.2641 110.672 12.0037 112.921 12.0037L112.916 12.0089ZM111.112 20.5818V21.6079H112.17C112.926 21.6079 113.41 21.5245 113.624 21.3579C113.839 21.1912 113.946 20.9725 113.946 20.7068V19.5298H112.889C112.272 19.5298 111.821 19.5922 111.536 19.7172C111.252 19.8422 111.112 20.1287 111.112 20.5818Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M126.572 8.25892V21.311C127.12 21.41 127.544 21.4673 127.834 21.4881L127.603 25.1652C125.402 25.1652 123.953 25.0402 123.249 24.7902C122.374 24.4725 121.832 24.0714 121.628 23.5923C121.489 23.2902 121.424 22.9412 121.424 22.5402V8.63392L126.578 8.25892H126.572Z",
            fill: "#030208"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "path",
          {
            d: "M134.404 20.6339V21.5089C134.92 21.561 135.435 21.5818 135.95 21.5818C137.55 21.5818 139.161 21.3318 140.792 20.8318L141.41 24.5089C139.488 25.0089 137.577 25.2589 135.687 25.2589C133.282 25.2589 131.543 24.712 130.469 23.6235C129.396 22.5297 128.859 20.8683 128.859 18.6339C128.859 16.3995 129.396 14.7381 130.469 13.6443C131.543 12.5506 133.277 12.0089 135.677 12.0089C138.076 12.0089 139.724 12.3266 140.637 12.9568C141.549 13.5922 142 14.7745 142 16.5089C142 17.9777 141.453 19.0297 140.363 19.6704C139.273 20.311 137.282 20.6339 134.399 20.6339H134.404ZM134.404 16.7068V17.7329H135.462C136.079 17.7329 136.53 17.6704 136.815 17.5454C137.099 17.4204 137.239 17.1339 137.239 16.6808V15.6547H136.181C135.564 15.6547 135.113 15.7172 134.828 15.8422C134.544 15.9672 134.404 16.2537 134.404 16.7068Z",
            fill: "#030208"
          }
        )
      ]
    }
  );
}
var import_jsx_runtime;
var init_Logo = __esm({
  "../../packages/ui/Logo.tsx"() {
    "use strict";
    import_jsx_runtime = require("react/jsx-runtime");
  }
});

// src/utils/tailwind-merge.ts
var import_tailwind_merge, twMerge;
var init_tailwind_merge = __esm({
  "src/utils/tailwind-merge.ts"() {
    "use strict";
    import_tailwind_merge = require("tailwind-merge");
    twMerge = (0, import_tailwind_merge.extendTailwindMerge)({
      prefix: "stringtale-"
    });
  }
});

// src/useFormat.tsx
function useFormat({
  format: format2,
  tags
}) {
  const context = (0, import_react3.useContext)(Context);
  return (0, import_react3.useMemo)(() => {
    if (!format2 && !(context == null ? void 0 : context.format) && !tags && !(context == null ? void 0 : context.tags)) {
      return null;
    }
    const t = __spreadValues(__spreadValues({}, tags), context == null ? void 0 : context.tags);
    const occurrences = /* @__PURE__ */ new Map();
    return __spreadValues(__spreadValues(__spreadValues({
      [RESET_TAG_KEYS]: () => occurrences.clear()
    }, context == null ? void 0 : context.format), format2), Object.keys(t).reduce((acc, key) => {
      acc[key] = (c) => {
        var _a;
        const [comp] = import_react3.Children.toArray(t[key]);
        if ((0, import_react3.isValidElement)(comp)) {
          const occurrence = (_a = occurrences.get(key)) != null ? _a : 0;
          occurrences.set(key, occurrence + 1);
          return (0, import_react3.cloneElement)(comp, {
            key: `${key}-${occurrence}`,
            children: c
          });
        }
        console.warn(`Invalid element: ${key}`, comp);
        return null;
      };
      return acc;
    }, {}));
  }, [format2, context == null ? void 0 : context.format, tags, context == null ? void 0 : context.tags]);
}
var import_react3, RESET_TAG_KEYS;
var init_useFormat = __esm({
  "src/useFormat.tsx"() {
    "use strict";
    import_react3 = require("react");
    init_StringtaleProviderBase();
    RESET_TAG_KEYS = /* @__PURE__ */ Symbol.for("stringtale.resetTagKeys");
  }
});

// src/FormatValue.tsx
function FormatValue({
  format: format2,
  locales,
  children
}) {
  const context = (0, import_react4.useContext)(Context);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_jsx_runtime2.Fragment, { children: (0, import_react4.useMemo)(() => {
    var _a;
    try {
      ;
      (_a = format2[RESET_TAG_KEYS]) == null ? void 0 : _a.call(format2);
      return new import_intl_messageformat.IntlMessageFormat(
        children,
        (context == null ? void 0 : context.locales) || locales
      ).format(format2);
    } catch (e) {
      if (e instanceof Error) {
        return e.toString();
      }
    }
  }, [children, context == null ? void 0 : context.locales, format2, locales]) });
}
var import_intl_messageformat, import_react4, import_jsx_runtime2;
var init_FormatValue = __esm({
  "src/FormatValue.tsx"() {
    "use strict";
    import_intl_messageformat = require("intl-messageformat");
    import_react4 = require("react");
    init_StringtaleProviderBase();
    init_useFormat();
    import_jsx_runtime2 = require("react/jsx-runtime");
  }
});

// src/htmlFormatTags.tsx
var import_jsx_runtime3, htmlFormatTags_default;
var init_htmlFormatTags = __esm({
  "src/htmlFormatTags.tsx"() {
    "use strict";
    import_jsx_runtime3 = require("react/jsx-runtime");
    htmlFormatTags_default = {
      ul: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("ul", { children: c }),
      ol: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("ol", { children: c }),
      li: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("li", { children: c }),
      p: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("p", { children: c }),
      b: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("b", { children: c }),
      i: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("i", { children: c }),
      u: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("u", { children: c }),
      h1: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("h1", { children: c }),
      h2: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("h2", { children: c }),
      h3: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("h3", { children: c }),
      h4: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("h4", { children: c }),
      h5: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("h5", { children: c }),
      h6: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("h6", { children: c }),
      blockquote: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("blockquote", { children: c }),
      pre: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("pre", { children: c }),
      code: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("code", { children: c }),
      em: (c) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("em", { children: c }),
      hr: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("hr", {}),
      br: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("br", {})
    };
  }
});

// src/components/Banner.tsx
function InnerBanner({ banner }) {
  if (!banner) return null;
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_jsx_runtime4.Fragment, { children: [
    banner.image ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      "img",
      {
        src: banner.image,
        alt: "",
        className: "stringtale-rounded-sm",
        width: "58",
        height: "58"
      }
    ) : null,
    /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "stringtale-flex stringtale-flex-col stringtale-gap-1", children: [
      /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { className: "stringtale-opacity-90", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FormatValue, { format: htmlFormatTags_default, children: banner.title }) }),
      banner.body ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { className: "stringtale-text-xs stringtale-opacity-50", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FormatValue, { format: htmlFormatTags_default, children: banner.body }) }) : null
    ] })
  ] });
}
function Banner({ banner }) {
  if (!banner) return null;
  const className = twMerge(
    "stringtale-flex stringtale-px-3 stringtale-py-5 stringtale-text-white stringtale-rounded-md stringtale-border stringtale-border-solid stringtale-border-st-grey-light stringtale-gap-3 stringtale-items-center stringtale-no-underline",
    !banner.image && "stringtale-text-center"
  );
  if (banner.link) {
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("a", { className, href: banner.link, target: "_blank", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(InnerBanner, { banner }) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(InnerBanner, { banner }) });
}
var import_jsx_runtime4;
var init_Banner = __esm({
  "src/components/Banner.tsx"() {
    "use strict";
    init_tailwind_merge();
    init_FormatValue();
    init_htmlFormatTags();
    import_jsx_runtime4 = require("react/jsx-runtime");
  }
});

// src/components/Button.tsx
function Button(_a) {
  var _b = _a, {
    variant = "neutral",
    className
  } = _b, props = __objRest(_b, [
    "variant",
    "className"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    "button",
    __spreadProps(__spreadValues({}, props), {
      className: twMerge(CLASSES[variant], className)
    })
  );
}
var import_jsx_runtime5, buttonBaseStyle, buttonStyle, CLASSES;
var init_Button = __esm({
  "src/components/Button.tsx"() {
    "use strict";
    init_tailwind_merge();
    import_jsx_runtime5 = require("react/jsx-runtime");
    buttonBaseStyle = "stringtale-bg-st-grey-dark stringtale-p-2.5 stringtale-border-st-grey-light stringtale-border-solid stringtale-border stringtale-rounded-lg stringtale-font-semibold stringtale-text-white stringtale-cursor-pointer stringtale-active:transform stringtale-active:translate-y-px stringtale-whitespace-nowrap stringtale-text-left";
    buttonStyle = twMerge(
      buttonBaseStyle,
      "stringtale-flex stringtale-justify-between stringtale-items-center"
    );
    CLASSES = {
      neutral: twMerge(
        buttonStyle,
        "hover:stringtale-border hover:stringtale-bg-[#373A40] hover:stringtale-border-white stringtale-active:stringtale-bg-[#3a4034]"
      ),
      primary: twMerge(
        buttonStyle,
        `stringtale-bg-[#FFE619] stringtale-border-[#FFE619] stringtale-text-black stringtale-disabled:stringtale-bg-[#C7C7C7] stringtale-disabled:stringtale-border-[#C7C7C7] hover:stringtale-bg-[#F1D917] hover:stringtale-border-[#D9C415]`
      ),
      round: twMerge(
        buttonStyle,
        `stringtale-w-[32px] stringtale-h-[32px] stringtale-flex stringtale-items-center stringtale-justify-center stringtale-border-none`
      ),
      success: twMerge(
        buttonStyle,
        "stringtale-bg-[#008E00] stringtale-border-[#008E00] stringtale-text-white  hover:stringtale-bg-[#008E00] hover:stringtale-border-[#008E00]"
      )
    };
  }
});

// src/components/Checkbox.tsx
function Checkbox(_a) {
  var _b = _a, { checked, className } = _b, props = __objRest(_b, ["checked", "className"]);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "stringtale-w-12 stringtale-h-[26px] stringtale-relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
      "div",
      {
        className: twMerge(
          "stringtale-w-12 stringtale-h-[26px] stringtale-left-0 stringtale-top-0 stringtale-absolute stringtale-bg-[#80867d] stringtale-rounded-[999px] stringtale-shadow-inner stringtale-border stringtale-border-black/20",
          checked && "stringtale-bg-yellow"
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
      "div",
      {
        className: twMerge(
          "stringtale-w-[18px] stringtale-h-[18px] stringtale-left-[4px] stringtale-translate-x-0 stringtale-top-[4px] stringtale-absolute stringtale-bg-white stringtale-rounded-[999px] stringtale-shadow stringtale-transform stringtale-transition-transform",
          checked && "stringtale-translate-x-5"
        )
      }
    )
  ] });
}
var import_jsx_runtime6;
var init_Checkbox = __esm({
  "src/components/Checkbox.tsx"() {
    "use strict";
    init_tailwind_merge();
    import_jsx_runtime6 = require("react/jsx-runtime");
  }
});

// src/components/CloseButton.tsx
function CloseButton(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    Button,
    __spreadProps(__spreadValues({
      variant: "neutral"
    }, props), {
      onMouseDown: (e) => e.stopPropagation(),
      children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("svg", { width: "20", height: "20", viewBox: "0 0 20 20", className: "stringtale-flex-shrink-0", children: /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("g", { transform: "translate(0.212 0.211)", children: [
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          "path",
          {
            d: "M13.288,3.5,3.5,13.288",
            transform: "translate(1.394 1.394)",
            fill: "none",
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
          "path",
          {
            d: "M3.5,3.5l9.788,9.788",
            transform: "translate(1.394 1.394)",
            fill: "none",
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
          }
        )
      ] }) })
    })
  );
}
var import_jsx_runtime7;
var init_CloseButton = __esm({
  "src/components/CloseButton.tsx"() {
    "use strict";
    init_Button();
    import_jsx_runtime7 = require("react/jsx-runtime");
  }
});

// src/components/ErrorMessage.tsx
function ErrorMessage({
  header,
  body
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
    "div",
    {
      className: `
        stringtale-px-3 stringtale-py-5 stringtale-text-white stringtale-rounded-md stringtale-bg-[#FFF2F1] stringtale-border-[#AE1D20]
        stringtale-border-solid stringtale-border stringtale-flex stringtale-gap-2 stringtale-items-center stringtale-text-black
      `,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
              "path",
              {
                d: "M12 8.99994V12.9999M12 15.9999H12.01M10.363 3.59095L2.25699 17.1249C2.08988 17.4143 2.00145 17.7424 2.0005 18.0766C1.99954 18.4108 2.08609 18.7393 2.25153 19.0297C2.41698 19.32 2.65555 19.562 2.94353 19.7315C3.2315 19.901 3.55884 19.9922 3.89299 19.9959H20.107C20.441 19.9921 20.7682 19.9009 21.056 19.7314C21.3438 19.562 21.5823 19.3201 21.7477 19.0299C21.9131 18.7397 21.9997 18.4113 21.9989 18.0773C21.9981 17.7433 21.9098 17.4153 21.743 17.1259L13.637 3.58994C13.4664 3.30845 13.2262 3.07569 12.9394 2.91414C12.6527 2.7526 12.3291 2.66772 12 2.66772C11.6709 2.66772 11.3473 2.7526 11.0605 2.91414C10.7738 3.07569 10.5335 3.30845 10.363 3.58994V3.59095Z",
                stroke: "#DC2626",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "stringtale-flex stringtale-flex-col", children: [
          /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "stringtale-text-[#DC2626] stringtale-font-semibold", children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(FormatValue, { format: htmlFormatTags_default, children: header }) }),
          body ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "stringtale-text-xs", children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(FormatValue, { format: htmlFormatTags_default, children: body }) }) : null
        ] })
      ]
    }
  );
}
var import_jsx_runtime8;
var init_ErrorMessage = __esm({
  "src/components/ErrorMessage.tsx"() {
    "use strict";
    init_FormatValue();
    init_htmlFormatTags();
    import_jsx_runtime8 = require("react/jsx-runtime");
  }
});

// src/utils/createGetDraggable.ts
function createGetDraggable() {
  let dragStartMousePoint = null;
  let dragStartElementPoint = null;
  return (elm, e) => {
    if (e.target instanceof HTMLElement) {
      if (e.target.tagName === "BUTTON") return;
      if (e.target.tagName === "INPUT") return;
      if (e.target.tagName === "TEXTAREA") return;
    }
    const { left, top } = elm.getBoundingClientRect();
    dragStartMousePoint = {
      left: e.clientX,
      top: e.clientY
    };
    dragStartElementPoint = {
      left,
      top
    };
    const onMouseUp = () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
      elm.removeEventListener("mouseup", onMouseUp);
    };
    const onMouseMove = (e2) => {
      if (!dragStartMousePoint) return;
      if (!dragStartElementPoint) return;
      if (!elm) return;
      const { left: left2, top: top2 } = dragStartElementPoint;
      const maxX = window.innerWidth - elm.offsetWidth;
      const maxY = window.innerHeight - elm.offsetHeight;
      const newX = left2 + (e2.clientX - dragStartMousePoint.left);
      const newY = top2 + (e2.clientY - dragStartMousePoint.top);
      elm.style.setProperty("--x", `${Math.min(
        Math.max(0, newX),
        maxX
      )}px`);
      elm.style.setProperty("--y", `${Math.min(
        Math.max(0, newY),
        maxY
      )}px`);
      elm.style.setProperty("--bottom", "none");
      elm.style.setProperty("--right", "none");
    };
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    elm.addEventListener("mouseup", onMouseUp);
  };
}
var init_createGetDraggable = __esm({
  "src/utils/createGetDraggable.ts"() {
    "use strict";
  }
});

// src/components/Screen.tsx
function Screen(_a) {
  var _b = _a, {
    position,
    className
  } = _b, props = __objRest(_b, [
    "position",
    "className"
  ]);
  const getDraggable = (0, import_react5.useMemo)(() => createGetDraggable(), []);
  const ref = (0, import_react5.useRef)(null);
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    "div",
    __spreadProps(__spreadValues({
      "data-st-toolbar": true,
      ref
    }, props), {
      className: twMerge(
        "stringtale-bg-st-grey-dark stringtale-p-3 stringtale-rounded-xl stringtale-flex stringtale-flex-col stringtale-gap-5 stringtale-font-sans stringtale-!pointer-events-auto stringtale-w-72 stringtale-cursor-grab",
        className
      ),
      style: {
        position: "fixed",
        zIndex: 2147483647,
        right: `var(--right, ${position === "top-right" ? "10px" : "calc(50% - 144px)"})`,
        top: `var(--y, ${position === "top-right" ? "10px" : "calc(50% - 100px)"})`,
        left: "var(--x, unset)",
        bottom: "var(--bottom, unset)"
      },
      onMouseDown: (e) => {
        if (ref.current) {
          getDraggable(ref.current, e.nativeEvent);
        }
      },
      onMouseUp: (e) => e.stopPropagation(),
      onClick: (e) => e.stopPropagation()
    })
  );
}
var import_react5, import_jsx_runtime9;
var init_Screen = __esm({
  "src/components/Screen.tsx"() {
    "use strict";
    import_react5 = require("react");
    init_createGetDraggable();
    init_tailwind_merge();
    import_jsx_runtime9 = require("react/jsx-runtime");
  }
});

// src/ToolbarMenuContent.tsx
function ToolbarMenuContent() {
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(import_jsx_runtime10.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
      "a",
      {
        href: "https://docs.stringtale.com",
        target: "_blank",
        className: "stringtale-text-white stringtale-no-underline",
        children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(Button, { className: "stringtale-w-full stringtale-gap-2", type: "button", children: [
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
            "svg",
            {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                "path",
                {
                  d: "M6.99999 14C5.95922 14.5876 5.11765 15.4726 4.58315 16.5416C4.04865 17.6106 3.84559 18.8148 3.99999 20C5.18515 20.1544 6.38942 19.9513 7.45841 19.4168C8.52741 18.8823 9.41242 18.0408 9.99999 17M4 13C5.78309 13.2119 7.44305 14.0175 8.71276 15.2872C9.98247 16.557 10.7881 18.2169 11 20C11.8839 19.4904 12.6233 18.7638 13.1482 17.8889C13.6732 17.014 13.9663 16.0197 14 15C15.6791 14.4093 17.1454 13.334 18.2133 11.91C19.2813 10.486 19.9031 8.77734 20 7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4C15.2227 4.09691 13.514 4.71867 12.09 5.78665C10.666 6.85464 9.59069 8.32089 9 10C7.98026 10.0337 6.98596 10.3268 6.11106 10.8518C5.23617 11.3767 4.50959 12.1161 4 13ZM14 9C14 9.26522 14.1054 9.51957 14.2929 9.70711C14.4804 9.89464 14.7348 10 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9C16 8.73478 15.8946 8.48043 15.7071 8.29289C15.5196 8.10536 15.2652 8 15 8C14.7348 8 14.4804 8.10536 14.2929 8.29289C14.1054 8.48043 14 8.73478 14 9Z",
                  stroke: "white",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "stringtale-flex-1", children: "How to get started" })
        ] })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
      "a",
      {
        href: "https://stringtale.com/app",
        target: "_blank",
        className: "stringtale-text-white stringtale-no-underline",
        children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(Button, { className: "stringtale-w-full stringtale-gap-2", type: "button", children: [
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
            "svg",
            {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                "path",
                {
                  d: "M6.99999 14C5.95922 14.5876 5.11765 15.4726 4.58315 16.5416C4.04865 17.6106 3.84559 18.8148 3.99999 20C5.18515 20.1544 6.38942 19.9513 7.45841 19.4168C8.52741 18.8823 9.41242 18.0408 9.99999 17M4 13C5.78309 13.2119 7.44305 14.0175 8.71276 15.2872C9.98247 16.557 10.7881 18.2169 11 20C11.8839 19.4904 12.6233 18.7638 13.1482 17.8889C13.6732 17.014 13.9663 16.0197 14 15C15.6791 14.4093 17.1454 13.334 18.2133 11.91C19.2813 10.486 19.9031 8.77734 20 7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4C15.2227 4.09691 13.514 4.71867 12.09 5.78665C10.666 6.85464 9.59069 8.32089 9 10C7.98026 10.0337 6.98596 10.3268 6.11106 10.8518C5.23617 11.3767 4.50959 12.1161 4 13ZM14 9C14 9.26522 14.1054 9.51957 14.2929 9.70711C14.4804 9.89464 14.7348 10 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9C16 8.73478 15.8946 8.48043 15.7071 8.29289C15.5196 8.10536 15.2652 8 15 8C14.7348 8 14.4804 8.10536 14.2929 8.29289C14.1054 8.48043 14 8.73478 14 9Z",
                  stroke: "white",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "stringtale-flex-1", children: "Dashboard" })
        ] })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
      "a",
      {
        href: "https://www.stringtale.com",
        target: "_blank",
        className: "stringtale-text-white stringtale-no-underline",
        children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(Button, { className: "stringtale-w-full stringtale-gap-2", type: "button", children: [
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
            "svg",
            {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                "path",
                {
                  d: "M12 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V12M11 13L20 4M20 4H15M20 4V9",
                  stroke: "white",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "stringtale-flex-1", children: "Stringtale.com" })
        ] })
      }
    )
  ] });
}
var import_jsx_runtime10;
var init_ToolbarMenuContent = __esm({
  "src/ToolbarMenuContent.tsx"() {
    "use strict";
    init_Button();
    import_jsx_runtime10 = require("react/jsx-runtime");
  }
});

// src/modals/Toolbar.tsx
var Toolbar_exports = {};
__export(Toolbar_exports, {
  default: () => Toolbar
});
function Toolbar({
  mode,
  setMode,
  isDirty,
  save,
  setSaveState,
  saveState,
  error,
  renderToolbarBefore,
  renderToolbarAfter,
  renderMenuBefore,
  renderMenuAfter
}) {
  const [isMenuVisible, setIsMenuVisible] = (0, import_react6.useState)(false);
  const [banner, setBanner] = (0, import_react6.useState)(null);
  const [isSmall, setSmall] = (0, import_react6.useState)(false);
  (0, import_react6.useEffect)(() => {
    fetch("https://api.stringtale.com/api/banner").then((res) => __async(null, null, function* () {
      if (res.ok) {
        const json = yield res.json();
        setBanner(json);
      }
    })).catch(() => {
    });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(Screen, { position: "top-right", children: [
    /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "stringtale-flex stringtale-items-center stringtale-justify-between", children: [
      /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(Logo, {}),
      /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "stringtale-flex stringtale-gap-1", children: [
        /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          Button,
          {
            variant: "neutral",
            type: "button",
            onClick: () => setSmall((s) => !s),
            children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("g", { opacity: "0.85", children: isSmall ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                  "rect",
                  {
                    x: "4",
                    y: "4",
                    rx: "2",
                    ry: "2",
                    width: "16",
                    height: "16",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ) : /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                  "path",
                  {
                    d: "M4 12H20M4",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ) })
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          Button,
          {
            variant: "neutral",
            type: "button",
            onClick: () => setIsMenuVisible((s) => !s),
            children: isMenuVisible ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("g", { opacity: "0.85", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                  "path",
                  {
                    d: "M5 12H19M5 12L11 18M5 12L11 6",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ) })
              }
            ) : /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("g", { opacity: "0.85", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                  "path",
                  {
                    d: "M4 6H20M4 12H20M4 18H20",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ) })
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          CloseButton,
          {
            type: "button",
            onMouseDown: (e) => e.stopPropagation(),
            onClick: () => {
              setMode("disabled");
            }
          }
        )
      ] })
    ] }),
    !isSmall && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "stringtale-flex stringtale-gap-4 stringtale-flex-col", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "stringtale-flex stringtale-gap-2 stringtale-flex-col", children: error ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
      ErrorMessage,
      {
        header: error,
        body: "Please contact your developer"
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: isMenuVisible ? /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_jsx_runtime11.Fragment, { children: [
      renderMenuBefore,
      /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(ToolbarMenuContent, {}),
      renderMenuAfter
    ] }) : /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_jsx_runtime11.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(Banner, { banner }),
      renderToolbarBefore,
      /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
        Button,
        {
          type: "button",
          variant: mode === "init" ? "primary" : "neutral",
          onMouseDown: (e) => e.stopPropagation(),
          onClick: (e) => {
            e.stopPropagation();
            setMode(
              (m) => m === "editing" ? "enabled" : "editing"
            );
          },
          className: "stringtale-gap-2",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("path", { d: "M0,0H20V20H0Z", fill: "none" }),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    "path",
                    {
                      d: "M10,2.5A2.5,2.5,0,0,0,7.5,5V15A2.5,2.5,0,0,0,10,17.5",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "1.667"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    "path",
                    {
                      d: "M5,2.5A2.5,2.5,0,0,1,7.5,5V15A2.5,2.5,0,0,1,5,17.5",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "1.667"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    "path",
                    {
                      d: "M10.833,5.833h5.833a.833.833,0,0,1,.833.833v6.667a.833.833,0,0,1-.833.833H10.833",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "1.667"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    "path",
                    {
                      d: "M4.167,5.833H3.333a.833.833,0,0,0-.833.833v6.667a.833.833,0,0,0,.833.833h.833",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "1.667"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    "path",
                    {
                      d: "M14.167,10h.008",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "1.667"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    "path",
                    {
                      d: "M10.833,10h.008",
                      fill: "none",
                      stroke: "currentColor",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: "1.667"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { className: "stringtale-flex-1", children: "Edit text" }),
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(Checkbox, { checked: mode === "editing" }),
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: mode === "editing" ? "On" : "Off" })
          ]
        }
      ),
      renderToolbarAfter,
      mode !== "init" && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_jsx_runtime11.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
          Button,
          {
            type: "button",
            variant: saveState === "saved" ? "success" : "primary",
            className: "stringtale-gap-2 stringtale-justify-start",
            onClick: save,
            onMouseDown: (e) => e.stopPropagation(),
            disabled: saveState === "idle" && !isDirty,
            children: [
              saveState === "saved" ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(SaveIcon, {}) : /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("path", { d: "M0,0H20V20H0Z", fill: "none" }),
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                      "path",
                      {
                        d: "M3.915,3.362,17.5,10,3.915,16.638a.419.419,0,0,1-.455-.1.463.463,0,0,1-.1-.473L5.417,10,3.36,3.938a.462.462,0,0,1,.1-.473.419.419,0,0,1,.455-.1Z",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.667"
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                      "path",
                      {
                        d: "M5.417,10H17.5",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.667"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: saveState === "saved" ? "Saved" : saveState === "saving" ? "Saving..." : "Save changes" })
            ]
          }
        ),
        saveState === "saved" ? /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
          "div",
          {
            className: "stringtale-flex stringtale-gap-2 stringtale-border-[#008E00] stringtale-border-2 stringtale-rounded-md stringtale-p-2 stringtale-bg-[#EBFAEB] stringtale-leading-normal",
            onClick: () => setSaveState("idle"),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "stringtale-flex stringtale-justify-center stringtale-items-center stringtale-w-[24px]", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(SaveIcon, { stroke: "#008E00" }) }),
              /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { children: [
                /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "stringtale-text-[#008E00] stringtale-text-[14px] stringtale-font-bold", children: "Done! Your update is saved." }),
                /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "stringtale-text-[12px]", children: "It will show up in the next release." })
              ] })
            ]
          }
        ) : null
      ] })
    ] }) }) }) })
  ] });
}
var import_react6, import_jsx_runtime11, SaveIcon;
var init_Toolbar = __esm({
  "src/modals/Toolbar.tsx"() {
    "use strict";
    import_react6 = require("react");
    init_Logo();
    init_Banner();
    init_Button();
    init_Checkbox();
    init_CloseButton();
    init_ErrorMessage();
    init_Screen();
    init_ToolbarMenuContent();
    import_jsx_runtime11 = require("react/jsx-runtime");
    SaveIcon = ({ stroke = "white" }) => {
      return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
            "path",
            {
              d: "M9 12L11 14L15 10M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z",
              stroke,
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        }
      );
    };
  }
});

// src/StringtaleProviderBase.tsx
function StringtaleProviderBase(_a) {
  var _b = _a, {
    outlineColor = "#ffffff",
    onChange,
    mode,
    format: format2,
    tags,
    locales,
    isToolbarHidden = false,
    renderToolbarAfter,
    renderToolbarBefore,
    renderMenuAfter,
    renderMenuBefore
  } = _b, props = __objRest(_b, [
    "outlineColor",
    "onChange",
    "mode",
    "format",
    "tags",
    "locales",
    "isToolbarHidden",
    "renderToolbarAfter",
    "renderToolbarBefore",
    "renderMenuAfter",
    "renderMenuBefore"
  ]);
  const savedCallback = (0, import_react7.useRef)(null);
  const [currentMode, setMode] = useSessionStorageState(
    "stringtale-mode",
    {
      defaultValue: mode || "disabled"
    }
  );
  const [infoKeyname, setInfoKeyName] = (0, import_react7.useState)(null);
  const [error, setError] = (0, import_react7.useState)(props.error || null);
  (0, import_react7.useEffect)(() => {
    setError(props.error || null);
  }, [props.error]);
  const [data, setData] = (0, import_react7.useState)(null);
  const changes = useStateWithUpdateControl(null);
  const [saveState, setSaveState] = (0, import_react7.useState)(
    "idle"
  );
  const isDirty = changes.useSelector((state) => !!state);
  const [body, setBody] = (0, import_react7.useState)();
  (0, import_react7.useEffect)(() => {
    setBody(document.body);
  }, []);
  (0, import_react7.useEffect)(() => {
    if (mode) {
      setMode(mode);
    }
  }, [mode, setMode]);
  (0, import_react7.useEffect)(() => {
    if (saveState === "saved") {
      const t = setTimeout(() => {
        setSaveState("idle");
      }, 3e3);
      return () => clearTimeout(t);
    }
  }, [saveState]);
  const save = (0, import_react7.useCallback)(() => __async(null, null, function* () {
    var _a2;
    console.log("SAVE");
    setError(null);
    setSaveState("saving");
    try {
      const state = changes.stateRef.current || {};
      const keys = Object.keys(state);
      yield onChange(
        keys.reduce((acc, key) => {
          acc[key] = state[key].value;
          return acc;
        }, {}),
        keys.reduce((acc, key) => {
          if (state[key].version) {
            acc[key] = state[key].oldValue;
          }
          return acc;
        }, {})
      );
      const newData = updateData(data, state);
      setData(newData);
      changes.setState({}, true);
      setSaveState("saved");
      (_a2 = savedCallback.current) == null ? void 0 : _a2.call(savedCallback);
    } catch (e) {
      console.log("e", e);
      if (e instanceof StringtaleError) {
        setError(e.message);
      }
      setSaveState("idle");
    }
  }), [changes, data, onChange]);
  const modeRef = (0, import_react7.useRef)(currentMode);
  (0, import_react7.useEffect)(() => {
    modeRef.current = currentMode;
  }, [currentMode]);
  (0, import_react7.useEffect)(() => {
    if (hasStringtaleParam()) {
      setMode("init");
    }
  }, [setMode]);
  (0, import_react7.useEffect)(() => {
    const handler = (e) => {
      var _a2;
      if (((_a2 = e.data) == null ? void 0 : _a2.type) === "stringtale-from-extension-save") {
        save();
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [save]);
  (0, import_react7.useEffect)(() => {
    const handler = (e) => {
      var _a2, _b2;
      if (((_a2 = e.data) == null ? void 0 : _a2.type) === "stringtale-from-extension-set-state") {
        setMode(e.data.state);
      }
      if (((_b2 = e.data) == null ? void 0 : _b2.type) === "stringtale-from-extension-get-state") {
        window.postMessage(
          {
            type: "stringtale-to-extension-set-state",
            state: modeRef.current
          },
          "*"
        );
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [setMode]);
  (0, import_react7.useEffect)(() => {
    window.postMessage(
      {
        type: "stringtale-to-extension-set-state",
        state: currentMode
      },
      "*"
    );
  }, [currentMode]);
  (0, import_react7.useEffect)(() => {
    if (currentMode === "disabled" && hasStringtaleParam()) {
      removeStringtaleParam();
    }
  }, [currentMode]);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)(
    Context.Provider,
    __spreadProps(__spreadValues({
      value: {
        outlineColor,
        setMode,
        mode: currentMode,
        onChange: (_a2, flush) => {
          var _b2 = _a2, { key } = _b2, value = __objRest(_b2, ["key"]);
          changes.setState((c) => {
            if ((c == null ? void 0 : c[key]) === value) {
              return c;
            }
            return __spreadProps(__spreadValues({}, c), { [key]: value });
          }, flush);
        },
        changes: changes.state || emptyObject,
        changesRef: changes.stateRef,
        data: currentMode === "disabled" ? null : data,
        setData,
        // lang,
        infoKeyname,
        setInfoKeyName,
        locales,
        format: format2,
        tags,
        savedCallback
      }
    }, props), {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(import_react7.Suspense, { fallback: null, children: currentMode !== "disabled" && (!!data || props.error) && !isToolbarHidden && /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
          Toolbar2,
          __spreadValues({}, {
            mode: currentMode,
            setMode,
            isDirty,
            save,
            saveState,
            error,
            renderToolbarAfter,
            renderToolbarBefore,
            renderMenuAfter,
            renderMenuBefore,
            setSaveState
          })
        ) }),
        props.children
      ]
    })
  );
}
var import_react7, import_jsx_runtime12, StringtaleError, Toolbar2, Context, emptyArray, useStringtaleContext, useStringtaleState, emptyObject;
var init_StringtaleProviderBase = __esm({
  "src/StringtaleProviderBase.tsx"() {
    "use strict";
    import_react7 = require("react");
    init_searchParam();
    init_useSessionStorageState();
    init_useStateWithUpdateControl();
    init_updateData();
    import_jsx_runtime12 = require("react/jsx-runtime");
    StringtaleError = class extends Error {
      constructor(message) {
        super(message);
        this.name = "StringtaleError";
      }
    };
    Toolbar2 = (0, import_react7.lazy)(() => Promise.resolve().then(() => (init_Toolbar(), Toolbar_exports)));
    Context = (0, import_react7.createContext)(null);
    emptyArray = [];
    useStringtaleContext = () => {
      const context = (0, import_react7.useContext)(Context);
      if (!context) {
        throw new Error("StringtaleProvider not found");
      }
      return context;
    };
    useStringtaleState = () => {
      const context = (0, import_react7.useContext)(Context);
      if (!context) {
        return [emptyArray, () => {
        }];
      }
      const { data, setData } = context;
      return [data, setData];
    };
    emptyObject = {};
  }
});

// src/modals/InfoScreen.tsx
var InfoScreen_exports = {};
__export(InfoScreen_exports, {
  default: () => InfoScreen
});
function InfoScreen({
  name,
  apiRoute
}) {
  var _a, _b, _c, _d, _e, _f, _g;
  const { setInfoKeyName } = useStringtaleContext();
  const [state, setState] = (0, import_react10.useState)(null);
  const [error, setError] = (0, import_react10.useState)(null);
  const [isLoading, setIsLoading] = (0, import_react10.useState)(false);
  const { changes, savedCallback } = useStringtaleContext();
  const history = changes[name];
  const doIt = (0, import_react10.useCallback)(() => __async(null, null, function* () {
    setIsLoading(true);
    const res = yield fetch(apiRoute, {
      body: JSON.stringify({
        type: "history",
        name
      }),
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (res.ok) {
      const json = yield res.json();
      setState(json);
    } else {
      const text = yield res.json();
      setError(text.message);
    }
    setIsLoading(false);
  }), [apiRoute, name]);
  (0, import_react10.useEffect)(() => {
    doIt();
    savedCallback.current = doIt;
    return () => {
      savedCallback.current = null;
    };
  }, [doIt, savedCallback]);
  const datesAndUsers = (0, import_react10.useMemo)(() => {
    var _a2, _b2, _c2;
    if (!state || !state.content) return null;
    let prevDate = (_a2 = state.content.values[0]) == null ? void 0 : _a2.createdAt;
    let prevUser = (_c2 = (_b2 = state.content.values[0]) == null ? void 0 : _b2.createdBy) == null ? void 0 : _c2.name;
    const history2 = [...state.content.history];
    const map = /* @__PURE__ */ new Map();
    history2.reverse().forEach((item) => {
      var _a3, _b3;
      if (item.batch) {
        map.set(item.id, {
          date: prevDate ? format(new Date(prevDate)) : "Unknown date",
          user: prevUser != null ? prevUser : "Unknown user"
        });
        prevDate = item.batch.date;
        prevUser = (_b3 = (_a3 = item.batch) == null ? void 0 : _a3.user) == null ? void 0 : _b3.name;
      }
    });
    return map;
  }, [state]);
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(
    Screen,
    {
      position: "center",
      className: "stringtale-max-h-[500px] stringtale-w-[376px] stringtale-p-0 stringtale-pb-3 gap-0",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-p-3 stringtale-bg-[#091001] stringtale-rounded-tl-xl stringtale-rounded-tr-xl stringtale-header-border stringtale-flex-col stringtale-justify-start stringtale-items-start stringtale-gap-2 inline-flex", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-pl-2 stringtale-inline-flex stringtale-justify-between stringtale-items-center stringtale-self-stretch", children: [
          /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-items-center stringtale-flex stringtale-gap-2 stringtale-justify-start", children: [
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  "path",
                  {
                    d: "M12 8.00006V12.0001L14 14.0001M3.05005 11.0001C3.27414 8.80013 4.30031 6.75968 5.93278 5.26803C7.56525 3.77639 9.68974 2.93795 11.9009 2.9127C14.1121 2.88744 16.2552 3.67713 17.9213 5.1311C19.5874 6.58507 20.6599 8.60155 20.9342 10.7958C21.2085 12.99 20.6654 15.2085 19.4084 17.0278C18.1515 18.8472 16.2687 20.1401 14.1193 20.6599C11.97 21.1797 9.70446 20.89 7.75504 19.8461C5.80563 18.8022 4.30877 17.0772 3.55005 15.0001M3.05005 20.0001V15.0001H8.05005",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-text-sm stringtale-text-white stringtale-font-normal", children: "Changelog text area" })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            CloseButton,
            {
              type: "button",
              onClick: () => {
                setInfoKeyName(null);
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-overflow-y-auto stringtale-pt-3 stringtale-flex-1", children: [
          error ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-px-3", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(ErrorMessage, { header: error }) }) : null,
          isLoading ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-pb-4 stringtale-text-white stringtale-text-center", children: "Loading..." }) : /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_jsx_runtime15.Fragment, { children: [
            (history == null ? void 0 : history.oldValue) ? /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_jsx_runtime15.Fragment, { children: [
              /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                HistoryItem,
                {
                  userName: "You (not saved)",
                  date: history.date ? format(new Date(history.date)) : "Unknown date",
                  oldValue: history.value,
                  name,
                  isCurrent: true,
                  isChanged: false
                }
              ),
              !(state == null ? void 0 : state.content) ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                HistoryItem,
                {
                  userName: "You",
                  date: "First version",
                  oldValue: history.oldValue,
                  name,
                  isCurrent: false,
                  isChanged: true
                }
              ) : null
            ] }) : null,
            (state == null ? void 0 : state.content) ? /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_jsx_runtime15.Fragment, { children: [
              state.content.values[0] ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                HistoryItem,
                {
                  userName: (_c = (_b = (_a = state.content.values[0]) == null ? void 0 : _a.modifiedBy) == null ? void 0 : _b.name) != null ? _c : void 0,
                  date: format(new Date((_d = state.content.values[0]) == null ? void 0 : _d.modifiedAt)),
                  oldValue: (_e = state.content.values[0]) == null ? void 0 : _e.value,
                  name,
                  isCurrent: !history,
                  isChanged: !!history
                }
              ) : null,
              (_f = state.content.history) == null ? void 0 : _f.map((item, i) => {
                var _a2, _b2;
                const dateAndUser = datesAndUsers == null ? void 0 : datesAndUsers.get(item.id);
                return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  HistoryItem,
                  {
                    userName: (_a2 = dateAndUser == null ? void 0 : dateAndUser.user) != null ? _a2 : void 0,
                    date: (_b2 = dateAndUser == null ? void 0 : dateAndUser.date) != null ? _b2 : "Unknown date",
                    oldValue: item.oldValue,
                    name,
                    isCurrent: false,
                    isChanged: !!history
                  },
                  i
                );
              }),
              state.content.values[0] ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                HistoryItem,
                {
                  userName: null,
                  date: "First version",
                  oldValue: (_g = state.content.values[0]) == null ? void 0 : _g.oldValue,
                  name,
                  isCurrent: false,
                  isChanged: !!history
                }
              ) : null
            ] }) : null,
            !(history == null ? void 0 : history.oldValue) && !(state == null ? void 0 : state.content) ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-pb-4 stringtale-text-white stringtale-text-center", children: "No edits have been made." }) : null
          ] })
        ] })
      ]
    }
  );
}
var import_react10, import_jsx_runtime15, format, HistoryItem;
var init_InfoScreen = __esm({
  "src/modals/InfoScreen.tsx"() {
    "use strict";
    import_react10 = require("react");
    init_Screen();
    init_CloseButton();
    init_StringtaleProviderBase();
    init_tailwind_merge();
    init_Button();
    init_ErrorMessage();
    import_jsx_runtime15 = require("react/jsx-runtime");
    format = (date) => {
      return `${date.toDateString()} ${date.toLocaleTimeString()}`;
    };
    HistoryItem = ({
      userName,
      date,
      oldValue,
      name,
      isCurrent,
      isChanged
    }) => {
      const { onChange } = useStringtaleContext();
      return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-px-3 stringtale-flex stringtale-flex-col stringtale-gap-2", children: [
        /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-flex", children: [
          /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-justify-center stringtale-flex stringtale-flex-col stringtale-flex-1 stringtale-gap-1", children: [
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-text-white stringtale-text-sm stringtale-font-semibold", children: date }),
            userName === null ? null : /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("div", { className: "stringtale-items-center stringtale-flex stringtale-gap-1", children: [
              /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-w-[9px] stringtale-h-[9px] stringtale-bg-[#d7a3ff] stringtale-rounded-full stringtale-border stringtale-border-black/20" }),
              /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-opacity-50 stringtale-text-xs stringtale-font-normal stringtale-text-white", children: userName ? userName : "Unknown user" })
            ] })
          ] }),
          isCurrent && !isChanged ? null : /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            Button,
            {
              onClick: () => {
                onChange(
                  {
                    key: name,
                    value: oldValue,
                    oldValue,
                    date: new Date(date)
                    // version: version ? parseInt(version) : undefined,
                  },
                  true
                );
              },
              children: "Restore"
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
          "div",
          {
            className: twMerge(
              "stringtale-p-2 stringtale-rounded",
              isCurrent ? "stringtale-bg-[#ebfaeb]" : "stringtale-bg-[#faeded]"
            ),
            children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { children: oldValue })
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "stringtale-my-4 stringtale-h-px stringtale-bg-white/20" })
      ] });
    };
  }
});

// src/index.tsx
var index_exports = {};
__export(index_exports, {
  HiddenValue: () => HiddenValue,
  StringtaleError: () => StringtaleError,
  StringtaleProvider: () => StringtaleProvider,
  StringtaleProviderBase: () => StringtaleProviderBase,
  Value: () => Value,
  hasStringtaleParam: () => hasStringtaleParam,
  htmlEmptyTags: () => htmlEmptyTags_default,
  htmlFormatTags: () => htmlFormatTags_default,
  htmlWrapTags: () => htmlWrapTags_default,
  isInsideToolbar: () => isInsideToolbar,
  useStringtaleContext: () => useStringtaleContext,
  useStringtaleState: () => useStringtaleState,
  useStringtaleValue: () => useStringtaleValue
});
module.exports = __toCommonJS(index_exports);
init_StringtaleProviderBase();

// src/StringtaleProvider.tsx
var import_react11 = require("react");

// ../../packages/config/const.ts
var DEFAULT_API_ROUTE = "/api/stringtale";
var ERROR_CODES = {
  CLI_NOT_ENABLED: 1e3,
  LOGIN_REQUIRED: 2001,
  INVALID_INPUT: 3e3,
  INTERNAL_SERVER_ERROR: 4e3
};

// src/StringtaleProvider.tsx
init_Button();
init_Checkbox();

// src/modals/LoginModal.tsx
var import_react8 = require("react");
init_Logo();
init_Button();
init_CloseButton();
init_StringtaleProviderBase();
init_Screen();
init_tailwind_merge();
init_ErrorMessage();
var import_jsx_runtime13 = require("react/jsx-runtime");
var LoginModal = ({ onLogin }) => {
  const [isLoggingIn, setIsLoggingIn] = (0, import_react8.useState)(false);
  const [error, setError] = (0, import_react8.useState)(null);
  const { mode, setMode } = useStringtaleContext();
  const passwordId = (0, import_react8.useId)();
  const usernameId = (0, import_react8.useId)();
  if (mode === "disabled") return null;
  const login = (e) => __async(null, null, function* () {
    setIsLoggingIn(true);
    setError(null);
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const body = {
      username: formData.get("username"),
      password: formData.get("password")
    };
    try {
      yield onLogin(body);
    } catch (e2) {
      if (e2 instanceof Error) {
        setError(e2.message);
      }
    }
    setIsLoggingIn(false);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(Screen, { position: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { className: "stringtale-flex stringtale-items-center stringtale-justify-between", children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(Logo, {}),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        CloseButton,
        {
          onMouseDown: (e) => e.stopPropagation(),
          onClick: () => {
            setMode("disabled");
          }
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(
      "form",
      {
        id: "form",
        onSubmit: login,
        className: "stringtale-flex stringtale-gap-3 stringtale-flex-col",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { className: "stringtale-gap-0 stringtale-flex stringtale-flex-col", children: [
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
              "label",
              {
                htmlFor: usernameId,
                className: "stringtale-text-xs stringtale-text-white",
                children: "Username"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
              "input",
              {
                type: "text",
                name: "username",
                placeholder: "Username",
                className: "stringtale-rounded-lg stringtale-p-2.5 stringtale-bg-white",
                id: usernameId
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { className: "stringtale-flex stringtale-flex-col stringtale-gap-0", children: [
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
              "label",
              {
                htmlFor: passwordId,
                className: "stringtale-text-xs stringtale-text-white",
                children: "Password"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
              "input",
              {
                type: "password",
                name: "password",
                placeholder: "Password",
                className: "stringtale-rounded-lg stringtale-p-2.5 stringtale-bg-white",
                id: passwordId
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
            "a",
            {
              href: "https://stringtale.com/forgot-password",
              className: "stringtale-text-xs stringtale-text-yellow",
              target: "_blank",
              rel: "noreferrer",
              children: "I forgot my password"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
            Button,
            {
              id: "login",
              variant: "primary",
              className: twMerge(
                "stringtale-justify-center stringtale-font-semibold",
                isLoggingIn && "stringtale-bg-[#D9C415] stringtale-border-[#D9C415]"
              ),
              children: isLoggingIn ? "Logging in..." : "Login"
            }
          ),
          error ? /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(ErrorMessage, { header: error }) : null
        ]
      }
    )
  ] });
};

// src/StringtaleProvider.tsx
init_StringtaleProviderBase();

// src/modals/CommentScreen.tsx
var import_react9 = require("react");
init_Button();
init_CloseButton();
init_Screen();
init_ErrorMessage();
var import_jsx_runtime14 = require("react/jsx-runtime");
function CommentScreen({
  onClose,
  apiRoute
}) {
  const [isSending, setIsSending] = (0, import_react9.useState)(false);
  const [isEmpty, setIsEmpty] = (0, import_react9.useState)(true);
  const [error, setError] = (0, import_react9.useState)(null);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
    Screen,
    {
      position: "center",
      className: "stringtale-gap-0 stringtale-pb-3 stringtale-w-[400px] p-0",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("div", { className: "stringtale-p-3 stringtale-bg-[#091001] stringtale-rounded-tl-xl stringtale-rounded-tr-xl stringtale-header-border stringtale-flex-col stringtale-justify-start stringtale-items-start stringtale-gap-2 stringtale-inline-flex", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("div", { className: "stringtale-inline-flex stringtale-justify-between stringtale-items-center stringtale-self-stretch", children: [
          /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("div", { className: "stringtale-flex stringtale-gap-2 stringtale-items-center stringtale-justify-start", children: [
            /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                  "path",
                  {
                    d: "M8 9H16M8 13H14M9 18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H15L12 21L9 18Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("div", { className: "stringtale-text-sm stringtale-text-white stringtale-font-normal", children: "Leave a note for your developer" })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
            CloseButton,
            {
              onClick: () => {
                onClose();
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("div", { className: "stringtale-p-3 stringtale-flex stringtale-flex-col stringtale-gap-2", children: [
          error ? /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(ErrorMessage, { header: error }) : null,
          /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
            "form",
            {
              onSubmit: (e) => __async(null, null, function* () {
                setIsSending(true);
                e.preventDefault();
                const data = new FormData(e.target);
                const comment = data.get("comment");
                const res = yield fetch(apiRoute, {
                  method: "POST",
                  body: JSON.stringify({
                    type: "comment",
                    comment,
                    link: location.href
                  })
                });
                if (!res.ok) {
                  const body = yield res.json();
                  setError(body.message);
                }
                setIsSending(false);
              }),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
                  "textarea",
                  {
                    className: "stringtale-w-full stringtale-h-[120px] stringtale-box-border stringtale-p-2.5 stringtale-rounded stringtale-shadow-inner stringtale-border stringtale-border-black/20 stringtale-justify-start stringtale-items-start stringtale-gap-2 stringtale-inline-flex stringtale-bg-white",
                    placeholder: "Describe your comment or request here. Be specific to help the developer understand your feedback.",
                    name: "comment",
                    onChange: (e) => {
                      setIsEmpty(e.target.value === "");
                    }
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("div", { className: "stringtale-flex stringtale-gap-2 stringtale-justify-end", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(Button, { type: "button", children: "Cancel" }),
                  /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(Button, { variant: "primary", disabled: isEmpty, children: isSending ? "Sending..." : "Send comment" })
                ] })
              ]
            }
          )
        ] })
      ]
    }
  );
}

// src/StringtaleProvider.tsx
var import_jsx_runtime16 = require("react/jsx-runtime");
var InfoScreenBase = (0, import_react11.lazy)(() => Promise.resolve().then(() => (init_InfoScreen(), InfoScreen_exports)));
var InfoButton = () => {
  const { mode, setMode } = useStringtaleContext();
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(
    Button,
    {
      type: "button",
      onClick: () => {
        setMode(mode === "info" ? "enabled" : "info");
      },
      variant: "neutral",
      className: "stringtale-gap-2",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
              "path",
              {
                d: "M12 8.00006V12.0001L14 14.0001M3.05005 11.0001C3.27414 8.80013 4.30031 6.75968 5.93278 5.26803C7.56525 3.77639 9.68974 2.93795 11.9009 2.9127C14.1121 2.88744 16.2552 3.67713 17.9213 5.1311C19.5874 6.58507 20.6599 8.60155 20.9342 10.7958C21.2085 12.99 20.6654 15.2085 19.4084 17.0278C18.1515 18.8472 16.2687 20.1401 14.1193 20.6599C11.97 21.1797 9.70446 20.89 7.75504 19.8461C5.80563 18.8022 4.30877 17.0772 3.55005 15.0001M3.05005 20.0001V15.0001H8.05005",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("span", { className: "stringtale-flex-1", children: "Changelog" }),
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(Checkbox, { checked: mode === "info" }),
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("span", { children: mode === "info" ? "On" : "Off" })
      ]
    }
  );
};
var InfoScreen2 = ({ apiRoute }) => {
  const { infoKeyname } = useStringtaleContext();
  if (!infoKeyname) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(import_react11.Suspense, { children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    InfoScreenBase,
    {
      name: infoKeyname,
      apiRoute
    },
    infoKeyname
  ) });
};
var LoginChecker = ({
  apiRoute,
  isLoggedIn,
  setIsLoggedIn,
  setRequireLogin
}) => {
  const { mode } = useStringtaleContext();
  (0, import_react11.useEffect)(() => {
    if (mode === "disabled") {
      return;
    }
    if (!isLoggedIn) {
      const doIt = () => __async(null, null, function* () {
        const res = yield fetch(apiRoute, {
          body: JSON.stringify({
            type: "login-check"
          }),
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        });
        if (res.ok) {
          const json = yield res.json();
          if (!json.loggedIn && json.code === ERROR_CODES.LOGIN_REQUIRED) {
            setRequireLogin();
          }
          setIsLoggedIn(json.loggedIn);
        }
      });
      doIt();
    }
  }, [apiRoute, isLoggedIn, mode]);
  return null;
};
var StringtaleProvider = (_a) => {
  var _b = _a, {
    apiRoute = DEFAULT_API_ROUTE,
    enableHistory,
    enableComments
  } = _b, props = __objRest(_b, [
    "apiRoute",
    "enableHistory",
    "enableComments"
  ]);
  const [isLoggedIn, setIsLoggedIn] = (0, import_react11.useState)(props.isLoggedIn);
  const [error, setError] = (0, import_react11.useState)(null);
  const [isCommentState, setCommentState] = (0, import_react11.useState)(false);
  const [requireLogin, setRequireLogin] = (0, import_react11.useState)(false);
  const save = (values, oldValues) => __async(null, null, function* () {
    const res = yield fetch(apiRoute, {
      body: JSON.stringify({
        type: "push",
        values,
        oldValues
      }),
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!res.ok) {
      const obj = yield res.json();
      throw new StringtaleError(obj.message || obj.error || "Failed to save");
    } else {
      const json = yield res.json();
      if (!json.success) {
        throw new StringtaleError(json.message);
      }
    }
  });
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(
    StringtaleProviderBase,
    __spreadProps(__spreadValues({}, props), {
      error,
      onChange: (values, oldValues) => __async(null, null, function* () {
        yield save(values, oldValues);
      }),
      isToolbarHidden: requireLogin && !isLoggedIn,
      renderToolbarBefore: requireLogin && enableComments && isLoggedIn ? /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(
        Button,
        {
          type: "button",
          onClick: () => {
            setCommentState((s) => !s);
          },
          variant: "neutral",
          className: "stringtale-gap-2",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
                  "path",
                  {
                    d: "M8 9H16M8 13H14M9 18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H15L12 21L9 18Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("span", { className: "stringtale-flex-1", children: "Comment" })
          ]
        }
      ) : void 0,
      renderToolbarAfter: requireLogin && enableHistory && isLoggedIn ? /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(InfoButton, {}) : void 0,
      renderMenuAfter: requireLogin && isLoggedIn ? /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(import_jsx_runtime16.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(
        Button,
        {
          type: "button",
          className: "stringtale-gap-2",
          onClick: () => __async(null, null, function* () {
            yield fetch(apiRoute, {
              method: "POST",
              body: JSON.stringify({
                type: "logout"
              })
            });
            setIsLoggedIn(false);
          }),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
              "svg",
              {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
                  "path",
                  {
                    d: "M10 8V6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0391 19.7893 19.5304 20 19 20H12C11.4696 20 10.9609 19.7893 10.5858 19.4142C10.2107 19.0391 10 18.5304 10 18V16M15 12H3M3 12L6 9M3 12L6 15",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("span", { className: "stringtale-flex-1", children: "Logout" })
          ]
        }
      ) }) : void 0,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          LoginChecker,
          {
            apiRoute,
            isLoggedIn: props.isLoggedIn || isLoggedIn || false,
            setIsLoggedIn,
            setRequireLogin: () => setRequireLogin(true)
          }
        ),
        isCommentState ? /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          CommentScreen,
          {
            apiRoute,
            onClose: () => setCommentState(false)
          }
        ) : null,
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(InfoScreen2, { apiRoute }),
        requireLogin && !isLoggedIn && /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          LoginModal,
          {
            onLogin: (body) => __async(null, null, function* () {
              const res = yield fetch(apiRoute, {
                body: JSON.stringify({
                  type: "login",
                  username: body.username,
                  password: body.password
                }),
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                }
              });
              if (!res.ok) {
                const obj = yield res.json();
                throw new StringtaleError(
                  obj.message || obj.error || "Failed to login"
                );
              } else {
                setError(null);
                setIsLoggedIn(true);
              }
            })
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
          DataLoader,
          {
            apiRoute,
            setError,
            isLoggedIn: isLoggedIn || false
          }
        ),
        props.children
      ]
    })
  );
};
var DataLoader = ({
  apiRoute,
  setError,
  isLoggedIn
}) => {
  const isLoading = (0, import_react11.useRef)(false);
  const { mode, data, setData } = useStringtaleContext();
  const shouldFetch = !data && mode !== "disabled";
  (0, import_react11.useEffect)(() => {
    if (!isLoggedIn) {
      return;
    }
    if (!isLoading.current && shouldFetch) {
      fetch(apiRoute).then((r) => __async(null, null, function* () {
        isLoading.current = true;
        if (r.ok) {
          const json = yield r.json();
          setData(json.content);
        } else {
          if (r.status === 404) {
            setError("Did not found a server configuration");
          } else {
            try {
              const json = yield r.json();
              setError(json.message);
            } catch (e) {
              setError(r.statusText);
            }
          }
        }
      }));
    }
  }, [shouldFetch, isLoggedIn, mode, apiRoute, setData, setError]);
  return null;
};

// src/Value.tsx
var import_dedent = __toESM(require("dedent"));
var import_react13 = require("react");
init_FormatValue();
init_StringtaleProviderBase();
init_useFormat();

// src/useStringtaleValue.ts
var import_react12 = require("react");
init_StringtaleProviderBase();
function useStringtaleValue(name, defaultValue, version) {
  var _a, _b, _c;
  const context = (0, import_react12.useContext)(Context);
  if (!context) {
    return [defaultValue, "unchanged"];
  }
  const { changes, data } = context;
  const value = (0, import_react12.useMemo)(() => {
    return data == null ? void 0 : data.find((d) => d.key === name && (!version || `${d.version}` !== version));
  }, [data, name, version]);
  return [
    ((_a = changes[name]) == null ? void 0 : _a.value) || ((_c = (_b = value == null ? void 0 : value.values) == null ? void 0 : _b[0]) == null ? void 0 : _c.value) || defaultValue,
    changes[name] ? "changed" : value ? "saved" : "unchanged"
  ];
}

// src/Value.tsx
init_tailwind_merge();
var import_jsx_runtime17 = require("react/jsx-runtime");
var removeIndention = (str) => {
  if (!str || !(typeof str === "string")) return str;
  return (0, import_dedent.default)(str);
};
var stopPropagation = (e) => {
  e.stopPropagation();
};
var stopPropagationAndPrevent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};
function replaceSelectedText(replacementFnc) {
  if (window.getSelection) {
    const sel = window.getSelection();
    if (sel == null ? void 0 : sel.rangeCount) {
      const newText = replacementFnc(sel.toString());
      const range = sel.getRangeAt(0);
      range.deleteContents();
      range.insertNode(document.createTextNode(newText));
    }
  } else if (document.selection && document.selection.createRange) {
    const range = document.selection.createRange();
    range.text = replacementFnc(range.text);
  }
}
function replaceSelectedTag(tag) {
  replaceSelectedText((c) => {
    if (c.startsWith(`<${tag}>`) && c.endsWith(`</${tag}>`)) {
      return c.slice(3, c.length - 4);
    }
    return `<${tag}>${c}</${tag}>`;
  });
}
function onKeyDownForKey(key, e, format2) {
  if (e.metaKey && e.key === key) {
    e.preventDefault();
    if (format2 == null ? void 0 : format2[key]) {
      replaceSelectedTag(key);
    }
  }
}
var UNCLICKABLE_PROPS = {
  onMouseEnter: stopPropagation,
  onMouseLeave: stopPropagation,
  onMouseMove: stopPropagation,
  onMouseOut: stopPropagation,
  onMouseOver: stopPropagation,
  onPointerDown: stopPropagation,
  onPointerUp: stopPropagation,
  onMouseDown: stopPropagation,
  onMouseUp: stopPropagation,
  onPointerMove: stopPropagation,
  onClick: stopPropagationAndPrevent
};
var statusBackgroundStyles = {
  unchanged: "stringtale-bg-[#228BE6]",
  changed: "stringtale-bg-[#7c5cff]",
  saved: "stringtale-bg-[#008e00]"
};
var statusBackgroundOpacityStyles = {
  unchanged: "stringtale-bg-[#228BE6]/10",
  changed: "stringtale-bg-[#7c5cff]/10",
  saved: "stringtale-bg-[#008e00]/10"
};
var statusOutlineStyles = {
  unchanged: "stringtale-outline-[#228BE6]",
  changed: "stringtale-outline-[#7c5cff]",
  saved: "stringtale-outline-[#008e00]"
};
var CheckIcon = /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
      "path",
      {
        d: "M5.33325 9.99996L8.66659 13.3333L15.3333 6.66663",
        stroke: "white",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
var Box = (_a) => {
  var _b = _a, {
    status
  } = _b, props = __objRest(_b, [
    "status"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    "div",
    __spreadValues({
      className: `stringtale-flex stringtale-absolute stringtale-justify-center stringtale-items-center stringtale-rounded-bl stringtale-w-[14px] stringtale-h-[14px] stringtale-top-[-1px] stringtale-right-[-1px] ${statusBackgroundStyles[status]}`
    }, props)
  );
};
function EditableValue(_a) {
  var _b = _a, {
    name,
    version,
    children,
    defaultValue
  } = _b, props = __objRest(_b, [
    "name",
    "version",
    "children",
    "defaultValue"
  ]);
  const { onChange, changesRef } = useStringtaleContext();
  const [value, status] = useStringtaleValue(name, void 0, version);
  const newValue = (0, import_react13.useMemo)(() => {
    return removeIndention(value || children || defaultValue || "");
  }, [value, children, defaultValue]);
  const listener = (0, import_react13.useCallback)(
    (e) => {
      var _a2, _b2;
      const updatedValue = ((_b2 = (_a2 = changesRef.current) == null ? void 0 : _a2[name]) == null ? void 0 : _b2.value) || newValue;
      if (e.currentTarget.innerText !== updatedValue) {
        onChange(
          {
            key: name,
            value: e.currentTarget.innerText,
            version: version ? parseInt(version) : void 0,
            oldValue: children || "",
            date: /* @__PURE__ */ new Date()
          },
          false
        );
      }
    },
    [children, name, newValue, onChange, version, changesRef]
  );
  const [isActive, setIsActive] = (0, import_react13.useState)(false);
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)(
    "div",
    {
      className: `stringtale-relative stringtale-outline-dashed stringtale-inherit ${isActive ? "stringtale-outline-2" : "stringtale-outline-px"} stringtale-whitespace-pre-wrap stringtale-cursor-text ${statusOutlineStyles[status]} ${statusBackgroundOpacityStyles[status]}`,
      style: {
        listStyleType: "none"
      },
      children: [
        !isActive ? /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Box, { status, children: status === "saved" ? CheckIcon : /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
          "svg",
          {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
              "path",
              {
                d: "M6 4.66669H14M10 4.66669V15.3334",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            )
          }
        ) }) : null,
        /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
          "div",
          __spreadProps(__spreadValues(__spreadValues(__spreadValues({
            style: {
              outline: "none"
            },
            className: "stringtale-inherit"
          }, props), UNCLICKABLE_PROPS), {
            suppressContentEditableWarning: true,
            contentEditable: "plaintext-only",
            translate: "no",
            spellCheck: "false",
            onKeyDown: (e) => {
              e.stopPropagation();
              onKeyDownForKey("b", e, props.format);
              onKeyDownForKey("i", e, props.format);
              onKeyDownForKey("u", e, props.format);
            },
            onKeyUp: stopPropagationAndPrevent,
            onKeyPress: stopPropagation,
            onFocus: (0, import_react13.useCallback)(() => {
              setIsActive(true);
            }, []),
            onBlur: (0, import_react13.useCallback)(
              (e) => {
                var _a2, _b2;
                setIsActive(false);
                const updatedValue = ((_b2 = (_a2 = changesRef.current) == null ? void 0 : _a2[name]) == null ? void 0 : _b2.value) || newValue;
                if (e.currentTarget.innerText === updatedValue) return;
                onChange(
                  {
                    key: name,
                    value: e.currentTarget.innerText,
                    version: version ? parseInt(version) : void 0,
                    oldValue: children || "",
                    date: /* @__PURE__ */ new Date()
                  },
                  true
                );
              },
              [name, newValue, onChange, version, children, changesRef]
            ),
            // onInput: listener,
            onDOMNodeInserted: listener,
            onDOMNodeRemoved: listener,
            onDOMCharacterDataModified: listener,
            onPaste: (event) => {
              event.preventDefault();
              const data = event.clipboardData;
              const plainText = data.getData("text/plain").trim();
              replaceSelectedText(() => plainText);
            }
          }), {
            children: newValue
          })
        )
      ]
    }
  );
}
function InnerValue2(props) {
  const _a = props, { name, version } = _a, newProps = __objRest(_a, ["name", "version"]);
  let [val] = useStringtaleValue(name, void 0, version);
  const format2 = useFormat(props);
  if (format2) {
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(FormatValue, __spreadProps(__spreadValues({}, props), { format: format2, children: val || props.children || props.defaultValue || "" }));
  }
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_jsx_runtime17.Fragment, { children: val || props.children || props.defaultValue });
}
function InnerValue(props) {
  const _a = props, { name, version } = _a, newProps = __objRest(_a, ["name", "version"]);
  const context = (0, import_react13.useContext)(Context);
  const format2 = useFormat(props);
  const [_, status] = useStringtaleValue(name, void 0, version);
  if ((context == null ? void 0 : context.mode) === "editing") {
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(EditableValue, __spreadProps(__spreadValues({}, props), { format: format2 ? format2 : void 0 }));
  }
  if ((context == null ? void 0 : context.mode) === "info") {
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)(
      "span",
      __spreadProps(__spreadValues({}, UNCLICKABLE_PROPS), {
        className: twMerge(
          "stringtale-inherit",
          `${statusOutlineStyles[status]} ${statusBackgroundOpacityStyles[status]} stringtale-outline stringtale-whitespace-pre-wrap stringtale-relative stringtale-cursor-pointer`,
          context.infoKeyname && context.infoKeyname === props.name ? "stringtale-outline-2" : "stringtale-outline-px"
        ),
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          context.setInfoKeyName(props.name);
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(InnerValue2, __spreadValues({}, props)),
          /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Box, { status, children: status === "saved" ? CheckIcon : /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)(
            "svg",
            {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
                  "path",
                  {
                    d: "M2 6C2 6.13261 2.05268 6.25979 2.14645 6.35355C2.24021 6.44732 2.36739 6.5 2.5 6.5C2.63261 6.5 2.75979 6.44732 2.85355 6.35355C2.94732 6.25979 3 6.13261 3 6C3 5.86739 2.94732 5.74021 2.85355 5.64645C2.75979 5.55268 2.63261 5.5 2.5 5.5C2.36739 5.5 2.24021 5.55268 2.14645 5.64645C2.05268 5.74021 2 5.86739 2 6Z",
                    fill: "white"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
                  "path",
                  {
                    d: "M5.5 6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74021 6.44732 5.86739 6.5 6 6.5C6.13261 6.5 6.25979 6.44732 6.35355 6.35355C6.44732 6.25979 6.5 6.13261 6.5 6C6.5 5.86739 6.44732 5.74021 6.35355 5.64645C6.25979 5.55268 6.13261 5.5 6 5.5C5.86739 5.5 5.74021 5.55268 5.64645 5.64645C5.55268 5.74021 5.5 5.86739 5.5 6Z",
                    fill: "white"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
                  "path",
                  {
                    d: "M9 6C9 6.13261 9.05268 6.25979 9.14645 6.35355C9.24021 6.44732 9.36739 6.5 9.5 6.5C9.63261 6.5 9.75979 6.44732 9.85355 6.35355C9.94732 6.25979 10 6.13261 10 6C10 5.86739 9.94732 5.74021 9.85355 5.64645C9.75979 5.55268 9.63261 5.5 9.5 5.5C9.36739 5.5 9.24021 5.55268 9.14645 5.64645C9.05268 5.74021 9 5.86739 9 6Z",
                    fill: "white"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
                  "path",
                  {
                    d: "M2 6C2 6.13261 2.05268 6.25979 2.14645 6.35355C2.24021 6.44732 2.36739 6.5 2.5 6.5C2.63261 6.5 2.75979 6.44732 2.85355 6.35355C2.94732 6.25979 3 6.13261 3 6C3 5.86739 2.94732 5.74021 2.85355 5.64645C2.75979 5.55268 2.63261 5.5 2.5 5.5C2.36739 5.5 2.24021 5.55268 2.14645 5.64645C2.05268 5.74021 2 5.86739 2 6Z",
                    stroke: "white",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
                  "path",
                  {
                    d: "M5.5 6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74021 6.44732 5.86739 6.5 6 6.5C6.13261 6.5 6.25979 6.44732 6.35355 6.35355C6.44732 6.25979 6.5 6.13261 6.5 6C6.5 5.86739 6.44732 5.74021 6.35355 5.64645C6.25979 5.55268 6.13261 5.5 6 5.5C5.86739 5.5 5.74021 5.55268 5.64645 5.64645C5.55268 5.74021 5.5 5.86739 5.5 6Z",
                    stroke: "white",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
                  "path",
                  {
                    d: "M9 6C9 6.13261 9.05268 6.25979 9.14645 6.35355C9.24021 6.44732 9.36739 6.5 9.5 6.5C9.63261 6.5 9.75979 6.44732 9.85355 6.35355C9.94732 6.25979 10 6.13261 10 6C10 5.86739 9.94732 5.74021 9.85355 5.64645C9.75979 5.55268 9.63261 5.5 9.5 5.5C9.36739 5.5 9.24021 5.55268 9.14645 5.64645C9.05268 5.74021 9 5.86739 9 6Z",
                    stroke: "white",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              ]
            }
          ) })
        ]
      })
    );
  }
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(InnerValue2, __spreadValues({}, props));
}
function Value(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  if (!("name" in props)) {
    if (children && !(typeof children === "string")) {
      return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
        InnerValue,
        __spreadProps(__spreadValues({
          format: children.__stringtaleParams
        }, props), {
          name: children.__stringtaleKey,
          children: children.__stringtaleValue
        })
      );
    }
    throw new Error("You need to provide a name or use toValueObject");
  }
  if (children && typeof children === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(InnerValue, __spreadProps(__spreadValues({}, props), { children }));
  }
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(InnerValue, __spreadValues({}, props));
}

// src/index.tsx
init_searchParam();

// src/HiddenValue.tsx
init_FormatValue();
init_useFormat();
var import_jsx_runtime18 = require("react/jsx-runtime");
function InnerValue3(props) {
  const _a = props, { name, version } = _a, newProps = __objRest(_a, ["name", "version"]);
  let [val] = useStringtaleValue(name, void 0, version);
  const format2 = useFormat(props);
  if (format2) {
    return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(FormatValue, __spreadProps(__spreadValues({}, props), { format: format2, children: val || props.children || "" }));
  }
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(import_jsx_runtime18.Fragment, { children: val || props.children });
}
function HiddenValue(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  if (!("name" in props)) {
    if (children && !(typeof children === "string")) {
      return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        InnerValue3,
        __spreadProps(__spreadValues({
          format: children.__stringtaleParams
        }, props), {
          name: children.__stringtaleKey,
          children: children.__stringtaleValue
        })
      );
    }
    throw new Error("You need to provide a name or use toValueObject");
  }
  if (children && typeof children === "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(InnerValue3, __spreadProps(__spreadValues({}, props), { children }));
  }
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(InnerValue3, __spreadValues({}, props));
}

// src/index.tsx
init_htmlFormatTags();

// src/htmlEmptyTags.tsx
var import_jsx_runtime19 = require("react/jsx-runtime");
var htmlEmptyTags_default = {
  hr: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("hr", {}),
  br: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("br", {})
};

// src/htmlWrapTags.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
var htmlWrapTags_default = {
  ul: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("ul", {}),
  ol: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("ol", {}),
  li: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("li", {}),
  p: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("p", {}),
  b: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("b", {}),
  i: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("i", {}),
  u: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("u", {}),
  h1: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("h1", {}),
  h2: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("h2", {}),
  h3: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("h3", {}),
  h4: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("h4", {}),
  h5: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("h5", {}),
  h6: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("h6", {}),
  blockquote: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("blockquote", {}),
  pre: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("pre", {}),
  code: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("code", {}),
  em: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("em", {})
};

// src/isInsideToolbar.ts
function isInsideToolbar(node) {
  if (!node) return false;
  const toolbar = document.querySelector("[data-st-toolbar]");
  if (!toolbar) return false;
  if (node instanceof Event) {
    node = node.target;
  }
  if (node instanceof Element) {
    return !!toolbar.contains(node);
  }
  return false;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  HiddenValue,
  StringtaleError,
  StringtaleProvider,
  StringtaleProviderBase,
  Value,
  hasStringtaleParam,
  htmlEmptyTags,
  htmlFormatTags,
  htmlWrapTags,
  isInsideToolbar,
  useStringtaleContext,
  useStringtaleState,
  useStringtaleValue
});
